import { useState } from "react";
import { SmartImage } from "./SmartImage";

export const IntroReadyPanel = ({ onEnter }) => {
  const [charging, setCharging] = useState(false);

  const handleClick = () => {
    if (charging) return;
    setCharging(true);
    setTimeout(onEnter, 300);
  };

  return (
    <div className="flex flex-col items-center text-center px-6 intro-fadein">
      <SmartImage
        src="/assets/logo.png"
        alt="Curb the Solana Bull"
        eager
        className="bull-glow rounded-2xl border border-[#9945FF]/40"
        style={{ width: "clamp(120px, 34vw, 200px)" }}
      />
      <h1
        className="font-marker gradient-sol text-glow-green mt-6 leading-none"
        style={{ fontSize: "clamp(3rem, 12vw, 5.5rem)" }}
        data-testid="intro-logo-title"
      >
        $CURB
      </h1>
      <p
        className="font-bebas tracking-[0.4em] text-[#c9a8ff] text-glow-purple mt-3"
        style={{ fontSize: "clamp(1rem, 4vw, 1.5rem)" }}
      >
        THE SOLANA BULL
      </p>
      <button
        onClick={handleClick}
        data-testid="intro-enter-button"
        className={`enter-chain-btn font-bebas tracking-[0.35em] mt-10 pl-[0.35em] ${charging ? "charging" : ""}`}
        style={{
          fontSize: "clamp(1.15rem, 4.5vw, 1.5rem)",
          padding: "0.9rem 3.2rem",
          minWidth: "44px",
          minHeight: "48px",
        }}
      >
        UNLEASH $CURB
      </button>
    </div>
  );
};
